<template>
  <div>
      <b-card no-body class="mb-2">
          <b-container fluid>
              <b-row class="p-1">
                  <b-col cols="12" md="12">
                      <b-card class="mb-0">
                          <b-row>
                              <b-col cols="12" class="pb-2">
                                  <div v-if="delivery.status === 'pendiente'">
                                      <b-btn 
                                          variant="outline-primary"
                                          @click="changeStatus('aprobado')"
                                      >
                                          Aprobar
                                      </b-btn>
                                      <b-btn 
                                          variant="outline-danger"
                                          @click="changeStatus('rechazado')"
                                          class="mx-1"
                                      >
                                          Rechazar
                                      </b-btn>
                                  </div>
                                  <span v-else>
                                      <b>{{  delivery.status.toUpperCase() + " el " + delivery.updated_at  }}</b>
                                  </span>
                                  <div class="alert alert-warning mt-1" v-if="delivery.status === 'rechazado' && delivery.rejected_reason">
                                      {{ delivery.rejected_reason  }}
                                  </div>
                                  <div class="alert alert-success mt-1" v-if="delivery.status === 'aprobado' && delivery.fee">
                                      {{ "Cuota moderadora: $ " + delivery.fee }}
                                  </div>
                              </b-col>
                          </b-row>
                          <b-row>
                              <b-col cols="12" md="6">
                                  <b-card class="border" title="Farmacia">
                                      <b-form-group>
                                          <label for=""><b>Farmacia</b></label>
                                          <span class="d-block">{{ delivery.customer.name }}</span>
                                      </b-form-group>
                                      <b-form-group>
                                          <label for=""><b>Télefono</b></label>
                                          <span class="d-block">{{ delivery.customer.phone }}</span>
                                      </b-form-group>
                                      <b-form-group>
                                          <label for=""><b>Celular</b></label>
                                          <span class="d-block">{{ delivery.customer.mobile }}</span>
                                      </b-form-group>
                                      <b-form-group>
                                          <label for=""><b>Correo</b></label>
                                          <span class="d-block">{{ delivery.customer.email }}</span>
                                      </b-form-group>

                                      <!-- La entidad determina contra que inventario se cruzan los
                                           medicamentos. Se puede corregir si la eligieron mal. -->
                                      <b-form-group class="mb-0">
                                          <label for=""><b>Entidad / EPS</b></label>

                                          <div v-if="!editandoEntidad" class="d-flex align-items-center">
                                              <span class="d-block">
                                                  {{ delivery.customers_has_entity_name || 'Sin entidad asignada' }}
                                              </span>
                                              <b-button variant="flat-primary" size="sm" class="ml-1 py-0 px-50"
                                                        @click="abrirEdicionEntidad">
                                                  <feather-icon icon="Edit2Icon" size="14" /> Cambiar
                                              </b-button>
                                          </div>

                                          <div v-else>
                                              <v-select v-model="entidadSeleccionada" :options="entidades"
                                                        label="name" :reduce="(o) => o.value" :clearable="false"
                                                        placeholder="Selecciona una entidad" />
                                              <small class="text-muted d-block mt-50">
                                                  Al cambiarla, el inventario se cruza contra el de la nueva entidad.
                                              </small>
                                              <div class="mt-1">
                                                  <b-button variant="primary" size="sm" :disabled="guardandoEntidad"
                                                            @click="guardarEntidad">
                                                      <b-spinner small v-if="guardandoEntidad" />
                                                      Guardar
                                                  </b-button>
                                                  <b-button variant="outline-secondary" size="sm" class="ml-50"
                                                            @click="editandoEntidad = false">
                                                      Cancelar
                                                  </b-button>
                                              </div>
                                          </div>
                                      </b-form-group>
                                  </b-card>
                              </b-col>
                              <b-col cols="12" md="6">
                                  <b-card class="border" title="Solicitante">
                                      <b-form-group>
                                          <label for=""><b>Nombre</b></label>
                                          <span class="d-block">{{ delivery.person.names }}</span>
                                      </b-form-group>
                                      <b-form-group>
                                          <label for=""><b>Apellido</b></label>
                                          <span class="d-block">{{ delivery.person.surnames }}</span>
                                      </b-form-group>
                                      <b-form-group>
                                          <label for=""><b>Teléfono</b></label>
                                          <span class="d-block">{{ delivery.person.phone }}</span>
                                      </b-form-group>
                                      <b-form-group>
                                          <label for=""><b>Correo</b></label>
                                          <span class="d-block">{{ delivery.person.email }}</span>
                                      </b-form-group>
                                  </b-card>                             
                              </b-col>
                          </b-row>
                          <b-row>
                              <b-col>
                                  <b-card class="border" title="Detalle de la entrega">
                                      <b-row>
                                          <b-col cols="12" md="6">
                                              <b-form-group>
                                                  <label for=""><b>Fecha de creación</b></label>
                                                  <span class="d-block">{{ delivery.created_at }}</span>
                                              </b-form-group>
                                              <b-form-group>
                                                  <label for=""><b>Fecha actualización</b></label>
                                                  <span class="d-block">{{ delivery.updated_at }}</span>
                                              </b-form-group>
                                              <b-form-group>
                                                  <label for=""><b>Precio</b></label>
                                                  <span class="d-block">$ {{ delivery.price }}</span>
                                              </b-form-group>
                                              <b-form-group>
                                                  <label for=""><b>Estado</b></label>
                                                  <span class="d-block">{{ delivery.status.toUpperCase() }}</span>
                                              </b-form-group>
                                              <b-form-group>
                                                  <label for=""><b>Dirección</b></label>
                                                  <span class="d-block">{{ delivery.address }}</span>
                                              </b-form-group>
                                          </b-col>
                                          <b-col cols="12" md="6">
                                              <p><b>Productos</b></p>
                                              <b-button variant="gradient-success" class="btn-icon float-right mb-2"
                                                  @click="showCums()">
                                                  <feather-icon icon="PlusIcon" />
                                              </b-button>
                                              <b-table responsive="sm" striped hover :per-page="perPage"
                                                  :current-page="currentPage" :items="itemsProducts"
                                                  :fields="fieldsProducts" :sort-by.sync="sortBy"
                                                  :sort-desc.sync="sortDesc" :sort-direction="sortDirection"
                                                  :filter="filter" :filter-included-fields="filterOn">
                                                  <template #cell(actions)="data">
                                                      <div class="d-flex">
                                                          <b-button variant="outline-primary"
                                                              class="btn-icon rounded-circle mr-1"
                                                              @click="editProduct(data.item)">
                                                              <feather-icon icon="EditIcon" />
                                                          </b-button>
                                                          <b-button variant="outline-danger"
                                                              class="btn-icon rounded-circle"
                                                              @click="deleteProduct(data.item.id)">
                                                              <feather-icon icon="TrashIcon" />
                                                          </b-button>
                                                      </div>
                                                  </template>
                                              </b-table>
                                              <b-col cols="12">
                                                  <b-pagination v-model="currentPage" :total-rows="totalRows"
                                                      :per-page="perPage" align="center" size="sm" class="my-0" />
                                              </b-col>
                                              <p><b>Formulas médicas</b></p>
                                              <b-table class="mt-1" responsive :items="delivery.orderFiles"
                                                  :fields="fields">
                                                  <template #cell(type)="data">
                                                      {{ getTypeFile(data) }}
                                                  </template>
                                                  <template #cell(actions)="data">
                                                      <b-button variant="gradient-primary" class="btn-icon"
                                                          @click="openModalFile(data.item)">
                                                          <feather-icon icon="EyeIcon" />
                                                      </b-button>
                                                      <b-button variant="gradient-primary" class="btn-icon"
                                                          @click="downloadFile(data.item)">
                                                          <feather-icon icon="DownloadIcon" />
                                                      </b-button>
                                                  </template>
                                              </b-table>
                                              <p><b>Autorizaciones</b></p>
                                              <b-table class="mt-1" responsive :items="delivery.licenseFiles"
                                                  :fields="fields">
                                                  <template #cell(type)="data">
                                                      {{ getTypeFile(data) }}
                                                  </template>
                                                  <template #cell(actions)="data">
                                                      <b-button variant="gradient-primary" class="btn-icon"
                                                          @click="openModalFile(data.item)">
                                                          <feather-icon icon="EyeIcon" />
                                                      </b-button>
                                                      <b-button variant="gradient-primary" class="btn-icon"
                                                          @click="downloadFile(data.item)">
                                                          <feather-icon icon="DownloadIcon" />
                                                      </b-button>
                                                  </template>
                                              </b-table>
                                          </b-col>
                                      </b-row>
                                      <b-row>
                                          <b-col>
                                              <hr>
                                              <b-form-group>
                                                  <label for=""><b>Código entrega</b></label>
                                                  <span class="d-block">{{ id }}</span>
                                              </b-form-group>
                                          </b-col>
                                      </b-row>
                                  </b-card>
                              </b-col>
                          </b-row>
                          <b-row>
                              <b-col cols="12" md="12">
                                  <b-card class="border" title="Seguimiento">
                                      <div v-if="!center.lat" class="text-center text-muted py-4">
                                          <feather-icon icon="MapPinIcon" size="28" class="mb-1 d-block mx-auto" />
                                          <small>Esta farmacia no tiene una ubicación registrada.</small>
                                      </div>
                                      <GmapMap
                                          v-else
                                          ref="map"
                                          :center="center"
                                          :zoom="13"
                                          style="width: 100%; height: 600px"
                                          :options="mapOptions"
                                      >
                                          <!-- Marcador de la tienda con ícono personalizado -->
                                          <GmapMarker
                                              v-if="center.lat && center.lng"
                                              :position="center"
                                              :icon="{
                                                  url: 'https://mimedicamento.com.co/img/logo.3a7c8281.svg',
                                                  scaledSize: { width: 32, height: 32 }
                                              }"
                                          />
                                          <!-- Marcador de la ubicación del cliente -->
                                          <GmapMarker
                                              v-if="customerMarker.lat && customerMarker.lng"
                                              :position="customerMarker"
                                          />
                                          <!-- Línea de ruta -->
                                          <GmapPolyline
                                              v-if="directions && directions.routes[0] && directions.routes[0].overview_path"
                                              :path="directions.routes[0].overview_path"
                                              :options="{
                                                  strokeColor: '#FF0000',
                                                  strokeOpacity: 1.0,
                                                  strokeWeight: 4
                                              }"
                                          />
                                      </GmapMap>
                                  </b-card>
                              </b-col>
                          </b-row>
                      </b-card>
                  </b-col>
              </b-row>
          </b-container>
      </b-card>
      <b-modal id="modal-center" v-model="modalFile.status" centered :title="modalFile.data.name" ok-only size="lg" fluid
            ok-title="Cerrar">
            <b-card-text>
                <b-embed v-if="modalFile.data.fileType == 'pdf'" type="iframe" :src="modalFile.data.path" />
                <b-img v-else-if="modalFile.data.fileType == 'image'" :src="modalFile.data.path" fluid />
            </b-card-text>
        </b-modal>
        <b-modal ref="products" centered title="Crear Productos" ok-only size="lg" fluid ok-title="Cerrar">
            <b-card-text>
                <b-row>
                    <b-col sm="12">
                        <b-button variant="gradient-info" class="btn-icon float-right mb-2" @click="openCums()">
                            <feather-icon icon="SearchIcon" /> Buscar Medicamentos
                        </b-button>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col sm="12">
                        <b-form-group label="Nombre Medicamento" v-if="edit == true">
                            <b-form-input v-model="form.name" placeholder="Nombre Medicamento" :disabled="edit" />
                        </b-form-group>
                        <b-form-group label="Nombre Medicamento" v-else>
                            <b-form-input v-model="form.name" placeholder="Nombre Medicamento" />
                        </b-form-group>
                    </b-col>
                    <b-col sm="12">
                        <b-form-group label="Cantidad Solicitada">
                            <b-form-input v-model="form.quantitySolitate" placeholder="Cantidad Solicitada" type="number" />
                        </b-form-group>
                    </b-col>
                    <b-col sm="12">
                        <b-form-group label="Cantidad Entregada">
                            <b-form-input v-model="form.deliveryQuantity" placeholder="Cantidad Entregada" type="number" />
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" class="text-center">
                        <b-button variant="gradient-success" class="btn-icon" @click="saveDeliveryHasStock()">
                            Guardar
                        </b-button>
                    </b-col>
                </b-row>
            </b-card-text>
        </b-modal>
        <cum-search-table ref="cumSearchTable" @searchCums="filterCums" :pharmacy="pharmacy" />
    </div>
</template>

<script>
import CumSearchTable from '../deliveries/CumsSearchTable.vue';
import { BModal, BTable } from 'bootstrap-vue'
import { gmapApi } from 'vue2-google-maps';
import vSelect from 'vue-select';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
export default {
    components: {
        CumSearchTable,
        BModal,
        BTable,
        vSelect,
        ToastificationContent
    },
    name: 'DeliveryDetail',
    data() {
        return {
            editandoEntidad: false,
            guardandoEntidad: false,
            entidades: [],
            entidadSeleccionada: null,
            // Sin valores inventados: antes el centro caia en Bogotá y el
            // marcador del solicitante en San Francisco cuando faltaba el
            // dato, mostrando ubicaciones que no existen.
            center: { lat: null, lng: null },
            customerMarker: { lat: null, lng: null },
            directions: null,
            mapOptions: {
              zoomControl: true,
              mapTypeControl: false,
              scaleControl: false,
              streetViewControl: false,
              rotateControl: false,
              fullscreenControl: true,
              disableDefaultUi: false,
            },
            form: {
                id: null,
                name: null,
                quantitySolitate: null,
                deliveryQuantity: null
            },
            id: this.$route.params.id,
            delivery: {
                customer: {
                    name: '',
                    phone: '',
                    mobile: '',
                    email: '',
                },
                person: {
                    names: '',
                    surnames: '',
                    phone: '',
                    email: '',
                },
                status: '',
                orderFiles: [],
                licenseFiles: [],
                rejected_reason: '',
            },
            pharmacy: null,
            fields: [
                { key: 'type', label: 'Tipo' },
                { key: 'name', label: 'Archivo' },
                { key: 'number', label: 'Número' },
                { key: 'actions', label: 'Acciones' },
            ],
            modalFile: {
                status: false,
                data: {
                    name: null,
                    path: null,
                    fileType: null,
                },
            },
            perPage: 5,
            pageOptions: [3, 5, 10],
            totalRows: 1,
            currentPage: 1,
            sortBy: '',
            sortDesc: false,
            sortDirection: 'asc',
            filter: null,
            filterOn: [],
            fieldsProducts: [
                { key: 'id', label: 'Id' },
                { key: 'cum', label: 'Cum' },
                { key: 'amount', label: 'C Solicitada', sortable: true },
                { key: 'delivered_quantity', label: 'C Entregada', sortable: true },
                { key: 'actions', label: 'Acciones', sortable: true },
            ],
            itemsProducts: [],
            stock: {},
            edit: false
        }
    },
    computed: {
      google() {
        return gmapApi() || null;
      }
    },
    mounted() {
      if (this.google && this.google.maps) {
        console.log('maps ok')
        this.getRoute(); // Llama a getRoute al montar el componente
      } else {
        this.$watch(
          () => this.google,
          (google) => {
            if (google && google.maps) {
              console.log('maps ok')
              this.getRoute(); // Llama a getRoute cuando la API esté lista
            }
          }
        );
      }
    },
    methods: {
        async getRoute() {
            if (this.google && this.google.maps) {
                const directionsService = new this.google.maps.DirectionsService();
                const request = {
                    origin: this.center,
                    destination: this.customerMarker,
                    travelMode: this.google.maps.TravelMode.DRIVING,
                    drivingOptions: {
                        departureTime: new Date(Date.now()),  // para obtener el tiempo estimado actual.
                        trafficModel: 'pessimistic'
                    }
                };
                directionsService.route(request, (result, status) => {
                    if (status === 'OK') {
                        this.directions = result;
                        this.$refs.map.panToBounds(result.routes[0].bounds);
                    } else {
                        console.error(`Error fetching directions: ${status}`);
                    }
                });
            }
        },
        async deleteProduct(id) {
            await this.$http.post('/entities/delete-deliveries-has-stocks/' + id).then((response) => {
                if (response.data.code == 200) {
                    this.$swal({
                        title: response.data.message,
                        icon: 'success',
                        customClass: {
                            confirmButton: 'btn btn-success',
                        },
                        buttonsStyling: false,
                    });
                    this.getDelivery().then(() => {
                        setTimeout(() => {
                            this.fetchDeliveriesHasStocks(this.delivery.id);
                        }, 2000);
                    });
                }
                if (response.data.code == 500) {
                    this.$swal({
                        title: response.data.message,
                        icon: 'warning',
                        customClass: {
                            confirmButton: 'btn btn-warning',
                        },
                        buttonsStyling: false,
                    })
                }
            }).catch((error) => {
                console.error('Error al enviar la solicitud POST:', error);
            });
        },
        async editProduct(data) {
            this.$refs['products'].show()
            this.edit = true
            this.form = {
                id: data.id,
                name: data.cum,
                quantitySolitate: data.amount,
                deliveryQuantity: data.delivered_quantity
            }
        },
        async fetchDeliveriesHasStocks(id) {
            const payload = {
                stock: this.stock
            };
            await this.$http.post('/entities/list-deliveries-has-stocks/' + id, payload).then((response) => {
                this.itemsProducts = response.data.deliveries;
            }).catch((error) => {
                console.error('Error al enviar la solicitud POST:', error);
            });
        },
        async saveDeliveryHasStock() {
            if (this.form.deliveryQuantity > this.stock.quantity) {
                this.$swal({
                    title: 'La cantidad especificada para la entrega supera el stock disponible del medicamento seleccionado. No es posible procesar la entrega con la cantidad ingresada. Por favor, verifique el inventario actual y actualice las cantidades disponibles o reduzca la cantidad especificada para la entrega.',
                    icon: 'error',
                    customClass: {
                        confirmButton: 'btn btn-success',
                    },
                    buttonsStyling: false,
                });
                return false
            }
            if (this.edit == true) {
                await this.$http.post('/entities/edit-deliveries-has-stocks/' + this.form.id + '/' + this.delivery.id, this.form).then((response) => {
                    if (response.data.code == 200) {
                        this.$swal({
                            title: response.data.message,
                            icon: 'success',
                            customClass: {
                                confirmButton: 'btn btn-success',
                            },
                            buttonsStyling: false,
                        });
                        this.$refs['products'].hide()
                        this.form = {
                            id: null,
                            name: null,
                            quantitySolitate: null,
                            deliveryQuantity: null
                        }
                        this.stock = response.data.stock
                        this.fetchDeliveriesHasStocks(this.delivery.id)
                    }
                    if (response.data.code == 500) {
                        this.$swal({
                            title: response.data.message,
                            icon: 'warning',
                            customClass: {
                                confirmButton: 'btn btn-warning',
                            },
                            buttonsStyling: false,
                        })
                    }
                }).catch((error) => {
                    console.error('Error al enviar la solicitud POST:', error);
                });
            } else {

                this.$http.post('/entities/store/' + this.delivery.id, this.form)
                    .then(response => {
                        if (response.data.code == 200) {
                            this.$swal({
                                title: response.data.message,
                                icon: 'success',
                                customClass: {
                                    confirmButton: 'btn btn-success',
                                },
                                buttonsStyling: false,
                            });
                            this.$refs['products'].hide()
                            this.form = {
                                id: null,
                                name: null,
                                quantitySolitate: null,
                                deliveryQuantity: null
                            }
                            this.stock = response.data.stock
                            this.fetchDeliveriesHasStocks(this.delivery.id)
                        }
                        if (response.data.code == 500) {
                            this.$swal({
                                title: response.data.message,
                                icon: 'warning',
                                customClass: {
                                    confirmButton: 'btn btn-warning',
                                },
                                buttonsStyling: false,
                            })
                        }
                    })
                    .catch((error) => {
                        this.errors = error.response.data.errors;
                    });
            }
        },
        filterCums(item) {
            this.form.id = item.id
            this.form.name = item.producto
            this.assignQuantity()
        },
        async assignQuantity() {
            await this.$http.post('/entities/search-cums-for-pharmacy-id/' + this.form.id, this.pharmacy).then((response) => {
                this.form.quantitySolitate = response.data.delivery.amount
                this.form.deliveryQuantity = response.data.delivery.delivered_quantity
                this.form.alert = response.data.alert
                this.stock = response.data.stock
            })
            this.tableSettings.busy = false;
        },
        showCums() {
            this.form = {
                id: null,
                name: null,
                quantitySolitate: null,
                deliveryQuantity: null
            }
            this.$refs['products'].show()
        },
        openCums() {
            this.pharmacy = this.delivery
            this.$refs.cumSearchTable.showModal();
        },

        async abrirEdicionEntidad() {
            this.entidadSeleccionada = this.delivery.customers_has_entity_id;
            this.editandoEntidad = true;

            if (!this.entidades.length) {
                await this.$http
                    .get(`/entities/selectForPharmacy/${this.delivery.customer.id}`)
                    .then(({ data }) => {
                        this.entidades = data.entities || [];
                    })
                    .catch(() => {
                        this.entidades = [];
                    });
            }
        },

        async guardarEntidad() {
            this.guardandoEntidad = true;

            await this.$http
                .put(`deliveries/${this.id}`, {
                    customers_has_entity_id: this.entidadSeleccionada,
                })
                .then(async () => {
                    this.editandoEntidad = false;
                    // Se recarga todo para que el buscador de medicamentos
                    // cruce contra el inventario de la nueva entidad.
                    await this.getDelivery();
                    this.$toast({
                        component: ToastificationContent,
                        position: 'top-right',
                        props: {
                            title: 'Entidad actualizada',
                            icon: 'CheckCircleIcon',
                            variant: 'success',
                            text: 'El inventario ahora se cruza contra esta entidad.',
                        },
                    });
                })
                .catch((error) => {
                    this.$toast({
                        component: ToastificationContent,
                        position: 'top-right',
                        props: {
                            title: 'Error',
                            icon: 'AlertCircleIcon',
                            variant: 'danger',
                            text: error?.response?.data?.message || 'No se pudo cambiar la entidad.',
                        },
                    });
                })
                .finally(() => {
                    this.guardandoEntidad = false;
                });
        },

        async getDelivery() {
            try {
                const { data } = await this.$http.get(`deliveries/${this.id}`);
                this.delivery = data;

                // La farmacia guarda lat/lng como columnas sueltas, no como un
                // objeto 'location': al preguntar por data.customer.location
                // la condicion nunca se cumplia y el mapa se quedaba en el
                // valor por defecto, que apuntaba a Bogotá.
                if (data.customer && data.customer.lat && data.customer.lng) {
                    this.center = {
                        lat: parseFloat(data.customer.lat),
                        lng: parseFloat(data.customer.lng),
                    };
                }

                if (data.lat && data.lng) {
                    this.customerMarker = {
                        lat: parseFloat(data.lat),
                        lng: parseFloat(data.lng),
                    };
                }

                // Llama a getRoute después de obtener los datos de entrega
                this.getRoute();

            } catch (error) {
                console.error('Error fetching delivery:', error);
            }
        },

        async changeStatus(status) {
            try {
                this.$swal({
                    title: `¿Está seguro de que quieres marcar como ${status}?`,
                    text: "Podrá revertir esta acción más tarde.",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Aceptar',
                    cancelButtonText: 'Cancelar',
                    customClass: {
                        confirmButton: 'btn btn-primary',
                        cancelButton: 'btn btn-outline-danger ml-1',
                    },
                    buttonsStyling: false,
                }).then(async result => {
                    if (result.value) {
                        if (status === 'aprobado') {
                            const { value: fee } = await this.$swal({
                                title: 'Ingrese la cuota moderadora',
                                input: 'text',
                                inputLabel: 'Cuota moderadora',
                                inputPlaceholder: '$ 0',
                                showCancelButton: true,
                                cancelButtonText: 'Cancelar',
                                confirmButtonText: 'Aceptar',
                                inputValidator: (value) => {
                                    // Validar que el valor sea numérico
                                    if (!value) {
                                        return 'Debe ingresar un valor';
                                    } else if (!/^[0-9]+([.][0-9]+)?$/.test(value)) {
                                        return 'Debe ingresar un valor numérico';
                                    }
                                }
                            });
                            
                            const { data } = await this.$http.put(`deliveries/${this.id}`, {status, fee});
                            this.delivery = data;
                            this.$swal({
                                title: '¡Listo!',
                                text: 'Se ha actualizado el estado de la entrega',
                                icon: 'success',
                                customClass: {
                                    confirmButton: 'btn btn-success',
                                },
                                buttonsStyling: false,
                            });
                        } else if (status === 'rechazado') {

                            const { value: rejected_reason } = await this.$swal({
                                title: 'Ingrese el motivo del rechazo',
                                input: 'textarea',
                                inputLabel: 'Motivo de rechazo',
                                inputPlaceholder: 'Motivo de rechazo',
                                showCancelButton: true,
                                cancelButtonText: 'Cancelar',
                                confirmButtonText: 'Aceptar',
                                inputValidator: (value) => {
                                    if (!value) {
                                        return 'Debe ingresar al menos un motivo';
                                    }
                                }
                            });

                            const { data } = await this.$http.put(`deliveries/${this.id}`, {status, rejected_reason});
                            this.delivery = data;
                            this.$swal({
                                title: '¡Listo!',
                                text: 'Se ha actualizado el estado de la entrega',
                                icon: 'success',
                                customClass: {
                                    confirmButton: 'btn btn-success',
                                },
                                buttonsStyling: false,
                            });
                        }
                    }
                });
            } catch (error) {
                console.error(error);
            }
        },

        getTypeFile(data) {
            const type = data.item.type === 'order' ? 'Orden médica' : data.item.type === 'license' ? 'Autorización' : '';
            return type;
        },
        openModalFile(data) {
            this.modalFile.status = true;
            this.modalFile.data = data;
        },
        modalFileReset() {
            this.modalFile = {
                status: false,
                data: {
                    name: null,
                    path: null,
                    fileType: null,
                },
            }
        },
        downloadFile(data) {
            window.open(data.path, '_blank');
        },
        handleRowClicked(itemId) {
            alert(itemId);
            console.log('Item clicado en otra vista:', itemId);
        },
    },
    created() {
        this.getDelivery().then(() => {
            setTimeout(() => {
                this.fetchDeliveriesHasStocks(this.delivery.id);
            }, 2000);
        });
        CumSearchTable.$on('row-clicked', this.handleRowClicked);
    },
    destroyed() {
        CumSearchTable.$off('row-clicked', this.handleRowClicked);
    },
}
</script>